import React from 'react'

import CustomFieldsManager from "../../../../gd/manager/custom-fields-manager"
import FieldButton from "../../../../gd-components/buttons/field-button/field-button"
import Project from "../../../../model2/project/project"
import TaskType from "../../../../model2/task-type/task-type"
import {CustomFieldScope} from "../../../../model2/custom-field/@const"
import SessionCustomField from "../../../../model2/custom-field/session-custom-field"

type Props = {
    project                 : Project
    taskType                : TaskType
    scope                   : CustomFieldScope

    searchString            : string

    onExistingFieldSelect   : {(customField: SessionCustomField): void}
}

export default function ExistingFields(props: Props) {

    let customFields = CustomFieldsManager.getAvailableCustomFields(
        props.project ? props.project.id : null,
        props.taskType ? props.taskType.id : null,
        props.scope ? props.scope : null,
        false
    )

    if (props.searchString) customFields = _.filter(customFields,customField=>gd.utils.search(customField.name, props.searchString))

    // customFields = _.sortBy(customFields, customField=>{ return customField.name.toLowerCase(); })
    customFields = _.sortBy(customFields, ['sortPosition'])

    const noResults = (!customFields || customFields.length<1)

    return (
        <div className="existing-fields">
            {!noResults && _.map(customFields, customField=>{
                return (
                    <FieldButton
                        key         = {customField.id}
                        className   = "m-r-15 m-b-10"
                        fieldId     = {customField.id}
                        displayIcon = {true}
                        onClick     = {props.onExistingFieldSelect.bind(null, customField)}
                    />
                )
            })}

            {noResults &&
                <div className="empty-label">No custom fields found</div>}

            <div className="cf"/>
        </div>
    )
}